import { apiUrl }  from "../constants";
var axios = require('axios');
var request = axios.create({
    baseURL: apiUrl
})
export default class LoginApi{
    static login(email, password){
        return request.post('/auth', {
            email: email,
            password: password
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/login.js